import { useState, useEffect, useRef, MutableRefObject } from "react";

import { isChild } from "../../../functions/general/checks";
import { format } from "date-fns";
import styles from "../../../styles/components/Table.module.scss";

import { useAppDispatch, useAppSelector } from "../../../hooks/redux";
import { useSelector } from "react-redux";
import { setUsers } from "../../../redux/actions";
import { RootState } from "../../../store";

type Props = {
    onViewDetail: (value:boolean) => void;
    onSelectUser: (value:User | null) => void;
    users: Array<User>
}

type SortingKeys = "lastname" | "username" | "relnr" | "datecreated" | "roleid"

type SortingSystem = {
    key?: SortingKeys,
    value?: "A" | "Z"
}

const ManagementTable: React.FunctionComponent<Props> = ({onSelectUser, onViewDetail, users}) => {
    const dispatch = useAppDispatch();

    //const roles = useAppSelector(state => state.roles);
    const usersRedux:User[] = useAppSelector((state:RootState) => state.users);

    const tableRef = useRef() as MutableRefObject<HTMLDivElement>;
    const [selectedRow, setselectedRow] = useState<User | null>();

    const [sortingState, setsortingState] = useState<SortingSystem>();

    useEffect(()=>{
        if(sortingState && Array.isArray(usersRedux)){
            let tmp_users = [...usersRedux];
            switch (sortingState.key) {
                case "lastname":
                    if(sortingState.value === "A"){
                        tmp_users.sort((a, b) => {
                            if (a.lastname > b.lastname) {
                                return -1;
                            }
                            if (a.lastname < b.lastname) {
                                return 1;
                            }
                            return 0;
                        })
                    }
                    else if(sortingState.value === "Z"){
                        tmp_users.sort((a, b) => {
                            if (b.lastname > a.lastname) {
                                return -1;
                            }
                            if (b.lastname < a.lastname) {
                                return 1;
                            }
                            return 0;
                        })
                    }
                    break;
                
                case "username":
                    if(sortingState.value === "A"){
                        tmp_users.sort((a, b) => {
                            if (a.username > b.username) {
                                return -1;
                            }
                            if (a.username < b.username) {
                                return 1;
                            }
                            return 0;
                        })
                    }
                    else if(sortingState.value === "Z"){
                        tmp_users.sort((a, b) => {
                            if (b.username > a.username) {
                                return -1;
                            }
                            if (b.username < a.username) {
                                return 1;
                            }
                            return 0;
                        })
                    }
                    break;

                case "relnr":
                    if(sortingState.value === "A"){
                        tmp_users.sort((a, b)=> a.relnr - b.relnr)
                    }
                    else if (sortingState.value === "Z"){
                        tmp_users.sort((a, b)=> b.relnr - a.relnr)
                    }
                    break;

                case "datecreated": 
                    if(sortingState.value === "A"){
                        tmp_users.sort((a, b)=> new Date(a.datecreated).getTime() - new Date(b.datecreated).getTime())
                    }
                    else if(sortingState.value === "Z") {
                        tmp_users.sort((a, b)=> new Date(b.datecreated).getTime() - new Date(a.datecreated).getTime())
                    }
                    break;

                case "roleid":
                    if(sortingState.value === "A"){
                        tmp_users.sort((a, b)=> a.roleid - b.roleid)
                    }
                    else if (sortingState.value === "Z"){
                        tmp_users.sort((a, b)=> b.roleid - a.roleid)
                    }
                    break;

                default:
                    break;
            }
            dispatch(setUsers(tmp_users))
        }
    }, [sortingState])

    const changeSorting = (key:SortingKeys) => {
        let obj = {...sortingState};
        obj.key = key;
        obj.value = obj.value === "Z" ? "A": "Z"
        setsortingState(obj);
    }

    const handleClickOutside = (e:any) => {
        let tr = tableRef.current;
        if(tr){
            if(!isChild(tr, e.target) && e.target.id !== "openTask"){
                setselectedRow(null);
                onSelectUser(null);
            } 
        }
    };

    useEffect(() => {
        document.addEventListener('touchstart', handleClickOutside);
        document.addEventListener('click', handleClickOutside);
        return () => {
            document.removeEventListener('touchstart', handleClickOutside);
            document.removeEventListener('click', handleClickOutside);
        }
    }, []); 

    return (
        <div ref={tableRef} className={styles.table_wrapper}>
            <div className={styles.table_inner_wrapper}>
                <table className={styles.table}>
                    <tbody>
                    <tr className={styles.th}>
                        <th onClick={()=>{changeSorting("lastname")}} className={styles.th_item}>Naam</th>
                        <th onClick={()=>{changeSorting("username")}} className={styles.th_item}>E-mailadres</th>
                        <td onClick={()=>{changeSorting("relnr")}} className={styles.th_item}>Partner</td>
                        <th onClick={()=>{changeSorting("datecreated")}} className={styles.th_item}>Aangemaakt op</th>
                        <th onClick={()=>{changeSorting("roleid")}} className={styles.th_item}>Rol</th>
                    </tr>
                    {Array.isArray(users) && users.map((user, index)=>{
                        return (
                            <tr onClick={()=>{onViewDetail(true); setselectedRow(user); onSelectUser(user)}} className={`${selectedRow?.apiuserid === user.apiuserid && styles.selected_tr} ${styles.tr}`} key={index}>
                                <td className={styles.td_item}>{user.firstname} {user.lastname}</td>
                                <td className={styles.td_item}>{user.username}</td>      
                                <td className={styles.td_item}>Partner</td>
                                <td className={styles.td_item}>{format(new Date(user.datecreated), "EE d MMM yyyy")}</td>
                                <td className={styles.td_item}>Onbekend</td>
                            </tr>
                        )
                    })}
                    </tbody>
                </table>
            </div>
        </div>
    )
}

export default ManagementTable;